<template>
    <div>
        <chart-toolbar :chart="chart" />
        <div style="position: relative; height: 250px">
            <canvas ref="canvas" />
        </div>
    </div>
</template>

<script>
import ChartToolbar from "@/modules/common/components/ChartToolbar";
import { Chart, defaultOptions, tickOptions } from "@/modules/chart.js";

export default {
    name: "ChartUnit",
    components: {
        ChartToolbar
    },
    props: {
        datasets: {
            type: Array,
            required: true
        },
        title: {
            type: String,
            required: false,
            default: ""
        },
        leftAxisTitle: {
            type: String,
            required: true
        },
        rightAxisTitle: {
            type: String,
            default: "Temperatura (°C)"
        }
    },
    data() {
        return {
            chart: null
        };
    },
    watch: {
        datasets() {
            this.chart.data.datasets = this.datasets;
            this.chart.update();
        }
    },
    mounted() {
        this.chart = new Chart(this.$refs.canvas, {
            type: "line",
            data: {
                datasets: this.datasets
            },
            options: {
                ...defaultOptions,
                title: {
                    display: this.title !== "",
                    text: this.title
                },
                scales: {
                    xAxes: [
                        {
                            display: "auto",
                            type: "time",
                            time: {
                                tooltipFormat: "DD/MM/YYYY HH:mm",
                                displayFormats: {
                                    hour: "D MMM HH:mm",
                                    day: "D MMM"
                                },
                                minUnit: "hour"
                            },
                            ticks: {
                                maxTicksLimit: 9
                            }
                        }
                    ],
                    yAxes: [
                        {
                            type: "linear",
                            id: "left-axis",
                            display: "auto",
                            scaleLabel: {
                                display: true,
                                fontStyle: "bold",
                                labelString: this.leftAxisTitle
                            },
                            ticks: {
                                ...tickOptions
                            }
                        },
                        {
                            type: "linear",
                            id: "right-axis",
                            display: "auto",
                            position: "right",
                            scaleLabel: {
                                display: true,
                                fontStyle: "bold",
                                labelString: this.rightAxisTitle
                            },
                            ticks: {
                                ...tickOptions
                            }
                        }
                    ]
                }
            }
        });
    },
    beforeDestroy() {
        this.chart?.destroy();
        this.chart = null;
    }
};
</script>
